import {createAsyncThunk} from '@reduxjs/toolkit';
import fetchRequest from './utils';

const getProducts = createAsyncThunk('products/getProducts', async (params) => fetchRequest('/products', 'GET', params));

export default getProducts;
